import { GdsServiceFragment } from '@websky/graphql';
import { GdsServiceById } from './types';

export function buildGdsServicesById(services: GdsServiceFragment[]): GdsServiceById {
	return services.reduce<GdsServiceById>((acc, service) => {
		acc[service.id] = service;

		return acc;
	}, {});
}
